(() => {
  const SELECTORS = {
    root: '[data-sticky-atc-root]',
    submit: '[data-sticky-atc-submit]',
    label: '[data-sticky-atc-label]',
  };

  function initStickyATC(productInfoEl) {
    const root = productInfoEl.querySelector(SELECTORS.root);
    if (!root) return;
    if (root.dataset.stickyAtcInitialized === 'true') return;

    const sectionId = root.dataset.sectionId;

    const stickySubmit = root.querySelector(SELECTORS.submit);
    const stickyLabel = root.querySelector(SELECTORS.label);

    const mainSubmit = productInfoEl.querySelector(`#ProductSubmitButton-${sectionId}`);
    const mainButtonsWrap = mainSubmit?.closest('.product-form__buttons') || productInfoEl.querySelector('.product-buy-buttons');
    const mainQtyForm = productInfoEl.querySelector(`#Quantity-Form-${sectionId}`) || productInfoEl.querySelector('.product-form__quantity');

    if (!stickySubmit || !stickyLabel) return;
    if (!mainSubmit) return;

    let visible = false;
    const visibility = new Map();

    const setVisible = (nextVisible) => {
      if (visible === nextVisible) return;
      visible = nextVisible;

      root.classList.toggle('sticky-atc--visible', visible);
      root.classList.toggle('sticky-atc--hidden', !visible);
      document.body.classList.toggle('sticky-atc-active', visible);
      syncButtonState();
    };

    const syncButtonState = () => {
      if (!mainSubmit) return;

      // Mirror disabled + aria-disabled (main uses aria-disabled during loading).
      stickySubmit.toggleAttribute('disabled', mainSubmit.hasAttribute('disabled'));
      const ariaDisabled = mainSubmit.getAttribute('aria-disabled');
      if (ariaDisabled === null) stickySubmit.removeAttribute('aria-disabled');
      else stickySubmit.setAttribute('aria-disabled', ariaDisabled);

      const mainLabel = mainSubmit.querySelector('span')?.textContent?.trim();
      if (mainLabel) stickyLabel.textContent = mainLabel;

      // Mirror spinner visibility if the main button is in loading state
      const mainIsLoading = mainSubmit.classList.contains('loading');
      stickySubmit.classList.toggle('loading', mainIsLoading);
      const stickySpinner = stickySubmit.querySelector('.loading__spinner');
      if (stickySpinner) stickySpinner.classList.toggle('hidden', !mainIsLoading);
    };

    // Submit main form when the sticky button is clicked.
    if (stickySubmit.dataset.stickyAtcClickBound !== 'true') {
      stickySubmit.dataset.stickyAtcClickBound = 'true';
      stickySubmit.addEventListener('click', (e) => {
        e.preventDefault();
        if (stickySubmit.hasAttribute('disabled') || stickySubmit.getAttribute('aria-disabled') === 'true') return;
        const currentMainSubmit = productInfoEl.querySelector(`#ProductSubmitButton-${sectionId}`);
        currentMainSubmit?.click();
      });
    }

    // Keep sticky label/disabled state in sync with main button.
    if (mainSubmit) {
      const mo = new MutationObserver(syncButtonState);
      mo.observe(mainSubmit, { attributes: true, subtree: true, childList: true });
    }

    const targets = [mainButtonsWrap, mainQtyForm].filter(Boolean);
    if (!targets.length) return;

    targets.forEach((t) => visibility.set(t, false));

    const recompute = () => {
      const anyVisible = Array.from(visibility.values()).some(Boolean);
      setVisible(!anyVisible);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => visibility.set(e.target, e.isIntersecting));
        recompute();
      },
      {
        root: null,
        threshold: 0.05,
      }
    );

    targets.forEach((t) => io.observe(t));

    // Initial sync
    syncButtonState();
    root.dataset.stickyAtcInitialized = 'true';
  }

  function initAll() {
    document.querySelectorAll('product-info[id^="MainProduct"]').forEach((el) => initStickyATC(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after product-info swap
  document.addEventListener('product-info:loaded', (e) => {
    const productInfoEl = e.target?.closest?.('product-info') || e.target;
    if (productInfoEl?.matches?.('product-info')) initStickyATC(productInfoEl);
  });
})();


